export default "__VITE_ASSET__GDTcL5P0__"